import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../Api/axios';
import {
  ForgotButton,
  ForgotContainer,
  ForgotForm,
  ForgotInput,
  ForgotWrapper,
  FeedbackText,
  SuccessMessage,
  ForgotHeader,
} from './forgotPasswordElements';

const ForgotPasswordSection = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setFeedback('E-mail cant be empty!');
      return;
    }

    try {
      axios.post(
        '/forgot',
        JSON.stringify({
          email,
        }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        },
      ).then((res) => {
        if (res.data.status === 'success') {
          setSuccess(true);
          setFeedback(res.data.message);
        } else setFeedback(res.data.message);
      }).catch((error) => {
        if (error.response.status === 400
          || error.response.status === 401) setFeedback(error.response.data.message);
        else if (error) setFeedback('No server response!');
        else {
          setFeedback('Something went wrong');
          console.log('Error', error.message);
        }
      });
    } catch (err) {
      if (!err?.response) setFeedback('No server response');
      else setFeedback('Login failed');
    }
  };

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [email]);

  return (
    <ForgotContainer>
      <ForgotWrapper>
        {!success ? (
          <>
            <ForgotHeader>Forgot Password</ForgotHeader>
            <ForgotForm onSubmit={handleSubmit}>
              <ForgotInput
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Please enter your e-mail here"
                type="email"
                name="email"
              />
              <ForgotButton type="submit">Send</ForgotButton>
              <FeedbackText>{feedback}</FeedbackText>
            </ForgotForm>
          </>
        ) : (
          <>
            <SuccessMessage>{feedback}</SuccessMessage>
            <ForgotButton onClick={() => navigate('/login')}>Back to login page</ForgotButton>
          </>
        )}
      </ForgotWrapper>
    </ForgotContainer>
  );
};

export default ForgotPasswordSection;
